import axios, { AxiosResponse } from "axios";
import { UserDTO } from "../../shared/types";
import { getAxiosHeaders } from "../../shared/AxiosAPI";
import { USER_APIS } from "../../api/apis";
import { EASY_EDU_SERVER_BASE_URL } from "../../../../environment";

export const getInitialUser = (): UserDTO => {
  return {
    name: undefined,
    loginId: undefined,
    email: undefined,
    password: undefined,
    gender: undefined,
    mobile: undefined,
    aadhaarNumber: undefined,
    roles: undefined,
    grades: undefined,
    admissionNo: undefined,
  };
};

export async function getUserBy(loginId: string): Promise<AxiosResponse> {
  console.log(">>> getUserBy");
  const currHeaders = getAxiosHeaders();
  return axios.get(EASY_EDU_SERVER_BASE_URL + USER_APIS.USERS + "/" + loginId, {
    headers: currHeaders,
  });
}
